/// <reference path="api.d.ts" />

namespace API.Client {
    'use strict';

    export interface Branch {

        /**
         * Identifier for a CVC Branch.
         */
        "cvcBranchCode"?: number;

        /**
         * Identifier for a CVC entity.
         */
        "personCode"?: number;

        /**
         * Display the name of CVC Branch.
         */
        "name"?: string;

        /**
         * Display the short name of CVC Branch.
         */
        "shortName"?: string;

        /**
         * Display the trading name of CVC Branch.
         */
        "tradingName"?: string;

        /**
         * Display the abbreviation name of CVC Branch.
         */
        "abbreviation"?: string;

        /**
         * True if this branch belongs to the CVC Company, False otherwise.
         */
        "ownedByCvc"?: boolean;

        /**
         * True if this is a administrative branch, False otherwise.
         */
        "administration"?: boolean;
    }

}
